import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createElementVNode as _createElementVNode, unref as _unref, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "detail_content" }

import { reactive, toRefs, ref } from "vue";
import ItemList from "./item-list.vue";
import Form from "./form.vue";
import Nav from "./nav.vue";
import { queryItemByServiceCode,getAesStr,onethingAnswerSubmit,onetThingBaseinfoSave } from "@/config/request";
import { AREA_ID,AREA_NAME, FORM_URL } from "@/config/const";
import { ElMessage } from "element-plus";


export default /*@__PURE__*/_defineComponent({
  __name: 'index',
  props: {
    publicData:{} as any
},
  setup(__props, { expose: __expose }) {

const props = __props
const data = reactive({
    itemList:[] as any,
})
const form = ref(null) as any
const { publicData } = toRefs(props) as any
console.log('publicData:::::',publicData?.value)

//  根据servicecode获取事项列表
const getItemList = async() => {
    if(publicData?.value){
        const params = {
            serviceCode: publicData.value.selectServiceCode
        }
        let res = await queryItemByServiceCode(params) as any
        if (res.code == 200) {
            data.itemList = res.result.records
        }
        console.log('data.itemList:::::',data.itemList)
    }
}

//  验证字段以及保存第一步的数据
const check = async() => {
    console.log('check');
    
    const formData = form.value.getFormData()
    let status = 200
    if(formData.basicInfo.preApasinfo.contactman === '' ||
        formData.basicInfo.preApasinfo.telphone === '' ||
        formData.basicInfo.preApasinfo.contactmanCardnumber === ''
    ){
        status = 500
        ElMessage.error('请完整填写申报信息')
    }else{
        let formUrl = FORM_URL + '?'
        let obj = {
            formId: formData.formJson.formId,
            projid: formData.basicInfo.preApasinfo.projid,
            applyCardnumber: formData.basicInfo.preApasinfo.applyCardnumber,
            serviceCode: formData.oneThing.modelCode,
            areaCode: AREA_ID,
            applyname: formData.basicInfo.preApasinfo.applyname,
            applyCardtype: formData.basicInfo.preApasinfo.applyCardtype,
            contactman: formData.basicInfo.preApasinfo.contactman,
            telphone: formData.basicInfo.preApasinfo.telphone,
            contactmanCardtype: formData.basicInfo.preApasinfo.contactmanCardtype,
            contactmanCardnumber: formData.basicInfo.preApasinfo.contactmanCardnumber,
            legalman:formData.basicInfo.preApasinfo.applyname
        };

        let jm = ''
        let pd = {
            paramData: JSON.stringify(obj)
        }
        let aesStr = await getAesStr(pd) as any
        console.log('aesStr',aesStr);

        if (aesStr.code === 0) {
            jm = aesStr.result;
        }
        if (jm != '') {
            formUrl += ('jm=' + jm)
        }
        formData.formUrl = formUrl
        formData.jmFormData = ''
        const receiveAddr = formData.basicInfo.addressee.sendProvince + formData.basicInfo.addressee.sendCity +
        formData.basicInfo.addressee.sendCounty + '/' + formData.basicInfo.preExpress.receiveAddr
        let params = {
            "preOnethingApasinfo": {
                "acceptTime": "",
                "address": "",
                "applicantCardNum": formData.basicInfo.preApasinfo.applyCardnumber,
                "applicantCardType": formData.basicInfo.preApasinfo.applyCardtype,
                "applicantName": formData.basicInfo.preApasinfo.applyname,
                "corpName": formData.basicInfo.preApasinfo.corpName,
                "applicantPhone": formData.basicInfo.preApasinfo.telphone,
                "applyFrom": 1,
                "applyProperty": "",
                "applyType": formData.basicInfo.preApasinfo.applyType,
                "areaCode": AREA_ID,
                "areaName": AREA_NAME,
                "baseCode": "",
                "belongDeptCode": "",
                "belongDeptId": "",
                "belongDeptIds": "",
                "belongDeptName": "",
                "belongSystem": formData.basicInfo.preApasinfo.belongsystem,
                "busiHandleItemCode": "",
                "busiMode": "",
                "busiModeDesc": "",
                "busiType": "",
                "byLaw": "",
                "cloudFormJsonarray": "",
                "contact": formData.basicInfo.preApasinfo.contactman,
                "contactmanCardnumber": formData.basicInfo.preApasinfo.applyCardnumber,
                "contactCardNum": formData.basicInfo.preApasinfo.applyCardnumber,
                "contactCardType": formData.basicInfo.preApasinfo.contactCardType,
                "contactMobile": formData.basicInfo.preApasinfo.telphone,
                "contactPhone": formData.basicInfo.preApasinfo.telphone,
                "createTime": formData.basicInfo.preApasinfo.createTime,
                "dataState": formData.basicInfo.preApasinfo.datastate,
                "dataVersion": formData.basicInfo.preApasinfo.dataversion,
                "deptId": formData.basicInfo.preApasinfo.deptid,
                "deptName": formData.basicInfo.preApasinfo.deptname,
                "deptType": "",
                "extend": "",
                "extendedToleranceDays": 0,
                "feeBasis": "",
                "flowXml": "",
                //  如果是预约业务  handleState存‘预约’两个字
                "handleState": formData.basicInfo.yyData.isyy || formData.basicInfo.preApasinfo.handleState,
                "handleType": "",
                "hasTake": "",
                "implementCode": "",
                "infoType": formData.basicInfo.preApasinfo.infotype,
                "isFee": "",
                "isInvest": 0,
                "isManubrium": "",
                "lastModifiedTime": "",
                "legalMan": formData.basicInfo.preApasinfo.applyname,
                "localLmplementCode": "",
                "modelId": formData.oneThing.modelCode,
                "name": formData.oneThing.modelName,
                "needPost": "",
                "onethingUnid": formData.basicInfo.preApasinfo.projid,
                "patchStartTime": "",
                "patchSupplementer": "",
                "patchTime": "",
                "phase": "",
                "postAreaCodeCity": "",
                "postAreaCodeCounty": "",
                "postAreaCodeProv": "",
                "postAreaNameCity": "",
                "postAreaNameCounty": "",
                "postAreaNameProv": "",
                "postCode": formData.basicInfo.preApasinfo.postcode,
                "postReceiveAddress": "",
                "postReceiveName": "ycypt",
                "postReceivePhone": "",
                "postReceivePostCode": "",
                "powerSource": "",
                "projRelativeId": "",
                "projectName": formData.basicInfo.preApasinfo.projectname,
                "projpwd": formData.basicInfo.preApasinfo.projpwd,
                "promiseAcceptTime": "",
                "promiseDays": formData.basicInfo.preApasinfoRelation.promiseDays,
                "promiseTime": "",
                "receiveTime": formData.basicInfo.preApasinfo.receivetime,
                "receiveUserId": formData.basicInfo.preApasinfo.receiveUseid, // 用户的信息
                "receiveUserName": formData.basicInfo.preApasinfo.applyname, // 用户的信息
                "relativeBusiId": "",
                "remark": "",
                "sceneServiceId": "",
                "serviceType": "",
                "serviceVersion": formData.basicInfo.preApasinfo.serviceversion,
                "ssOrgCode": formData.basicInfo.preApasinfoRelation.ssOrgcode,
                "supplementWay": "",
                "syncStatus": "",
                "syncTag": "",
                "tags": "",
                "toleranceLimitTime": "",
                "tolerancePatchTime": "",
                "toleranceReason": "",
                "toleranceRemindTime": "",
                "toleranceState": "",
                "toleranceSupplementer": "",
                "transactTime": "",
                "uniteId": formData.oneThing.unid,
                "uniteName": formData.oneThing.modelClassName,
                "useLevel": 0,
                "windowId": "",
                "dieTime": formData.basicInfo.other.sgDate
            },
            "preOnethingApasinfoRelation": {
                "createBy": "",
                "createTime": formData.basicInfo.preApasinfo.createTime,
                "formDataid": "",
                "formUnid": "",
                "legalDays": 0,
                "modelName": formData.oneThing.modelName,
                "modelType": "",
                "onethingUnid": formData.basicInfo.preApasinfo.projid,
                "promiseDays": 0,
                "sysOrgCode": "",
                "updateBy": "",
                "updateTime": "",
                "username": "一件事网厅收件",
                "userName": "一件事网厅收件",
                "isSmqj": '0',    //  是否上门取件（0否，1是）
                "isJgyd": formData.basicInfo.preApasinfoRelation.isJgydStatus?'1':'2',    //  是否结果邮寄（0否，1是）
                "chooseService": publicData.value.selectServiceCode,
            },
            "preExpress": {    //  结果邮递信息
                "sendRegionCode": '',
                "receiveRegionCode": formData.basicInfo.addressee.regionCode,
                "projid": formData.basicInfo.preApasinfo.projid,
                "products": '',
                "takePostno": '',
                "postUnitname": '',
                "sendUnitname": '',
                "sendUser": '',
                "sendPhone": '',
                "receiveName": formData.basicInfo.preExpress.receiveName,
                "receivePhone": formData.basicInfo.preExpress.receivePhone,
                "receiveAddr": receiveAddr,
                "receivePost": formData.basicInfo.preExpress.receivePost,
                "remark": formData.basicInfo.preExpress.remark,
                "belongsystem": formData.basicInfo.preApasinfo.belongsystem,
                "areacode": formData.basicInfo.preApasinfo.areacode,
                "extend": 'I',
                "createTime": formData.basicInfo.preApasinfo.createTime,
                "syncStatus": 'I',
                "dataversion": 0,
                "isChecked": '',
                "exBatch": 0,
                "lastUpdateTime": '',
                "receiveProvince": formData.basicInfo.addressee.sendProvince,
                "receiveCity": formData.basicInfo.addressee.sendCity,
                "receiveCounty": formData.basicInfo.addressee.sendCounty,
            },
            "preExpressSmqj": {   //  上门取件邮递信息
                "sendRegionCode": '',
                "receiveRegionCode": '',
                "areacode": "",
                "belongsystem": formData.basicInfo.preApasinfo.belongsystem,
                "createTime": "",
                "dataversion": 0,
                "exBatch": 0,
                "extend": "I",
                "isChecked": "",
                "isConfirm": "0",
                "isPrint": "0",
                "lastUpdateTime": "",
                "postUnitname": "",
                "products": "",
                "projid": formData.basicInfo.preApasinfo.projid,

                "receiveAddr": '',  //  收件人信息（直接选择）
                "receiveCounty": '',
                "receiveName": '',
                "receivePhone": '',
                "receivePost": '',
                "receiveProvince": '',
                "receiveCity": '',

                "remark": '',    //  寄件人信息（自己填写）
                "sendCity": '',
                "sendCounty": '',
                "sendPhone": '',
                "sendProvince": '',
                "sendUnitname": '',
                "sendUser": '',
                "sendType": '',

                "sfqrts": "",
                "sfyjts": "",
                "sfyjwc": "",
                "syncStatus": "",
                "takePostno": ""
            }
        }
        publicData.value.answerInfo.serviceNameArray = [];
        publicData.value.answerInfo.serviceUnid = publicData.value.selectServiceCode;
        let params2 = {
            key: JSON.stringify(publicData.value.answerInfo)
        }
        let a = await onethingAnswerSubmit(params2)
        console.log('问题指引保存--',a);
        console.log('applyCardnumber--',formData.basicInfo.preApasinfo.applyCardnumber);
        console.log('保存参数--',params);
        let res = await onetThingBaseinfoSave(params) as any
        console.log('保存步骤1返回值--',res);
        status = res.code
        if(status != 200){
            ElMessage.error('保存信息失败')
        }else{
            ElMessage.success('保存信息成功')
        }
    }

    let result = {
        data:formData,
        status: status
    }
    return result
}

__expose({
    check,
})
const init = () => {
    getItemList()
}
init()

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(Nav),
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", null, [
        _cache[0] || (_cache[0] = _createElementVNode("div", { class: "t6_title_h2" }, "引导事项名称", -1)),
        _createVNode(ItemList, {
          itemList: data.itemList
        }, null, 8, ["itemList"])
      ]),
      _createElementVNode("div", null, [
        _cache[1] || (_cache[1] = _createElementVNode("div", { class: "t6_title_h2" }, "申请人信息", -1)),
        _createVNode(Form, {
          ref_key: "form",
          ref: form,
          publicData: _unref(publicData)
        }, null, 8, ["publicData"])
      ])
    ])
  ], 64))
}
}

})